import { SupervisorEmailCTA } from "../../../../src/components/ctas/supervisor_email";
import * as React from 'react';
export default {
  SupervisorEmailCTA,
  React
};